__turbopack_context__.v({
  "social": "index-module-scss-module__ygC4ba__social",
  "social__links": "index-module-scss-module__ygC4ba__social__links",
});
